import { Box, Button, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import DownloadIcon from "@mui/icons-material/Download";

function CV() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        py: 4,
        height: "85vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <Typography variant="h1" fontWeight={700} sx={{ flexGrow: 1 }}>
          Resume
        </Typography>
        <Button
          variant="outlined"
          href="/Resume.pdf"
          download="Ryan_Dean_Resume.pdf"
          startIcon={<DownloadIcon />}
          sx={{
            borderColor: theme.palette.secondary.main,
            textTransform: "none",
          }}
        >
          Download PDF
        </Button>
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: 1,
        }}
      >
        <iframe
          src="/Resume.pdf"
          width="100%"
          height="100%"
          style={{ border: "none", borderRadius: "4px" }}
          title="Resume"
        />
      </Box>
    </Box>
  );
}

export default CV;
